// @ vendors
const moment = require('moment');

// @ helpers
const { APIPost } = require('utilities/APIRequestHelper');

// @ constants
const actionTypes = require('constants/actionTypes');
const { CATEGORY_TYPE_ACCOUNT } = require('constants/index');
const { DATE_FORMAT_API } = require('constants/index');
const { PFM_NEW_FEATURES } = require('constants/flagBasedFeatures');

// @ commons
const apiURLBuilder = require('core/apiURLBuilder');

// @ actions
const { updateAccountTransactionCategory } = require('actions/getAccountsTransactions');
const { updateCardTransactionCategory } = require('actions/getCardsTransactions');
const { requestExpenses, requestExpensesByCategory } = require('actions/globalPositionExpenses');

const open = (type, id, movementId, category, subcategory, description, date = '', amount = 0, categoryCode, subCategoryCode) => ({
    type: actionTypes.CATEGORY_UPDATE_OPEN,
    payload: {
        type,
        id, // accountId or cardId
        movementId,
        category,
        subcategory,
        description,
        amount,
        date,
        categoryCode,
        subCategoryCode
    }
});

const close = () => ({
    type: actionTypes.CATEGORY_UPDATE_CLOSE
});

const setCategory = category => ({
    type: actionTypes.CATEGORY_UPDATE_SET_CATEGORY,
    payload: {
        category
    }
});

const setSubcategory = subcategory => ({
    type: actionTypes.CATEGORY_UPDATE_SET_SUBCATEGORY,
    payload: {
        subcategory
    }
});

const categoryUpdateRequest = () => ({
    type: actionTypes.CATEGORY_UPDATE_REQUEST
});

const categoryUpdateSuccess = data => ({
    type: actionTypes.CATEGORY_UPDATE_SUCCESS,
    payload: {
        data
    }
});

const categoryUpdateFailure = error => ({
    type: actionTypes.CATEGORY_UPDATE_FAILURE,
    payload: {
        error
    }
});

const requestChangeCategory = (byCategory, categoryCode, subCategoryCode) => (dispatch, getState) => {
    const immCategoryUpdate = getState().categoryUpdate;
    const type = immCategoryUpdate.get('type');
    const id = immCategoryUpdate.get('id');
    const movementId = immCategoryUpdate.get('movementId');
    const category = categoryCode ? categoryCode : immCategoryUpdate.get('category');
    const oldCategory = getState().globalPosition.getIn(['expenses', 'expensesByCategory', movementId, 'categories']);
    const subcategory = subCategoryCode ? subCategoryCode : immCategoryUpdate.get('subcategory');
    const hasNewPFMFeaturesFF = getState().flagBasedFeatures ?  getState().flagBasedFeatures.get(PFM_NEW_FEATURES) : false;
    let params;
    let accountNumber; // cuenta "prod:numeroContrato" - tarjeta "pan"
    let amount;
    let date;
    if (type === CATEGORY_TYPE_ACCOUNT) {

        const immAccount = getState().accounts.getIn(['byId', id]);

        accountNumber = `${immAccount.get('product')}:${immAccount.get('contractNumber')}`;

        if (byCategory) {
            amount = immCategoryUpdate.get('amount');
            date = moment(immCategoryUpdate.get('date')).format(DATE_FORMAT_API);
        } else {
            const immAccountTransaction = getState().accountsTransactions.getIn([id, 'byId', movementId]);
            amount = immAccountTransaction.getIn(['balance', 'amount']);
            date = immAccountTransaction.get('date');
        }
    } else {

        const immCard = getState().cards.getIn(['byId', id]);
        accountNumber = immCard.get('number');

        if (byCategory) {
            amount = immCategoryUpdate.get('amount');
            date = moment(immCategoryUpdate.get('date')).format(DATE_FORMAT_API);
        } else {
            const immCardTransaction = getState().cardsTransactions.getIn([id, 'byId', movementId]);
            amount = immCardTransaction.getIn(['import', 'amount']);
            date = immCardTransaction.get('date');
        }
    }

    if(hasNewPFMFeaturesFF) {
        params = {
            header: {
                version: 2
            },
            query: {
                accountNumber,
                categoryCode,
                subCategoryCode,
                accountType: type, // 0 cuenta corriente - 1 tarjeta de credito
                ammount: amount,
                concept: immCategoryUpdate.get('description'),
                dateOf: date
            }
        };
    } else {
        params = {
            query: {
                accountNumber,
                category: immCategoryUpdate.get('category'),
                subCategory: immCategoryUpdate.get('subcategory'),
                accountType: type, // 0 cuenta corriente - 1 tarjeta de credito
                ammount: amount,
                concept: immCategoryUpdate.get('description'),
                dateOf: date
            }
        };
    }

    dispatch(categoryUpdateRequest());
    return APIPost({
        dispatch,
        params,
        url: apiURLBuilder.getURL('changeTransactionCategory')
    })
        .then(response =>  {
            dispatch(categoryUpdateSuccess(response));

            dispatch(requestExpensesByCategory(oldCategory));
            dispatch(requestExpenses());

            if (type === CATEGORY_TYPE_ACCOUNT) {
                return dispatch(updateAccountTransactionCategory(id, movementId, category, subcategory));
            } else {
                return dispatch(updateCardTransactionCategory(id, movementId, category, subcategory));
            }
        })
        .catch(response => dispatch(categoryUpdateFailure(response.error.description)))
};

module.exports = {
    requestChangeCategory,
    open,
    close,
    setCategory,
    setSubcategory
};
